module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_8023.d69a152a.png";